import styled, { css } from 'styled-components';
import { textEllipsis } from '@/views/styles/function';
import { font, gutter } from '@/views/styles/variables';

export type ColorType = 'primary' | 'secondary' | 'warning' | 'danger' | 'success';

interface TextInterface {
  $gutter?: 'top' | 'bottom' | 'off';
  $textAlign?: 'center' | 'left' | 'right';
  $textLight?: boolean;
  $textDarkBlue?: boolean;
  $textDisabled?: boolean;
  $size?: 'small' | 'large' | 'title';
  $weight?: string;
  $alignSelf?: string;
  $wrap?: boolean;
  $color?: ColorType;
  $inverse?: boolean;
}

interface LinkTextInterface {
  $gutter?: 'top' | 'bottom';
  $textAlign?: 'center' | 'left' | 'right';
  $underline?: boolean;
  onClick?: any;
}

export const PageTitle = styled.h1<{
  $textAlign?: 'center' | 'left' | 'right';
  $gutterBottomOff?: boolean;
  $textDarkBlue?: boolean;
  $noMargin?: boolean;
}>`
  font-size: ${font.size.heading.h3};
  color: ${({ theme }) => theme.text.title};
  ${props => props.$textAlign === 'center' && css`
    text-align: center;
  `}
  ${props => props.$textAlign === 'left' && css`
    text-align: left;
  `}
  ${props => props.$textAlign === 'right' && css`
    text-align: right;
  `}
  ${props => props.$gutterBottomOff && css`
    margin-bottom: 0;
  `}
  ${props => props.$noMargin && css`
    margin: 0;
  `}

  button {
    margin-left: ${gutter.default};
    line-height: 0;

    label {
      margin-left: ${gutter.small};
      font-size: ${font.size.buttonText.small}; 
    }
  }
`;

export const Text = styled.p<TextInterface>`
  color: ${({ theme }) => theme.font.color.default};

  ${props => props.$textDisabled && css`
  color: ${({ theme }) => theme.font.color.disabled};
  `}

  ${props => props.$gutter === 'top' && css`
    margin-top: ${gutter.default};
  `}

  ${props => props.$gutter === 'bottom' && css`
    margin-bottom: ${gutter.default};
  `}

  ${props => props.$gutter === 'off' && css`
    margin: 0;
  `}

  ${props => props.$textAlign === 'center' && css`
    text-align: center;
  `}

  ${props => props.$textAlign === 'left' && css`
    text-align: left;
  `}

  ${props => props.$textAlign === 'right' && css`
    text-align: right;
  `}

  ${props => props.$size === 'small' && css`
    font-size: ${font.size.body.small};
  `}

  ${props => props.$size === 'large' && css`
    font-size: ${font.size.body.medium};
  `}

  ${props => props.$size === 'title' && css`
    font-size: ${font.size.body.large};
  `}

  ${props => props.$weight === 'semibold' && css`
    font-weight: ${font.weight.semibold};
  `}

  ${props => props.$alignSelf === 'center' && css`
    align-self: center;
  `}

  ${props => props.$wrap && css`
    ${textEllipsis('1')}
  `}

  ${props => props.$color === 'primary' && css`
    color: ${({ theme }) => theme.colors.primary.default};
  `}
  ${props => props.$color === 'danger' && css`
    color: ${({ theme }) => theme.colors.danger.default};
  `}
  ${props => props.$color === 'success' && css`
    color: ${({ theme }) => theme.colors.success.default};
  `}
  ${props => props.$color === 'warning' && css`
    color: ${({ theme }) => theme.colors.warning.default};
  `}
`;

export const LinkText = styled.a<LinkTextInterface>`
  color: ${({ theme }) => theme.link.color};
  ${props => props.$gutter === 'top' && css`
    margin-top: ${gutter.default};
  `}

  ${props => props.$gutter === 'bottom' && css`
    margin-bottom: ${gutter.default};
  `}

  ${props => props.$textAlign === 'center' && css`
    text-align: center;
    display: block;
  `}

  ${props => props.$textAlign === 'left' && css`
    text-align: left;
    display: block;
  `}

  ${props => props.$textAlign === 'right' && css`
    text-align: right;
    display: block;
  `}

  ${props => props.$underline && css`
    text-decoration: underline;
  `}
`;